import React, {useState,useEffect} from "react";
import { Col, Modal, Row } from "react-bootstrap";
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete";
import BtnAdd from "../../Components/Commons/Buttons/BtnAdd";
import { refreshPage, formatPrice } from "../../Helpers/Utils/Common";
import { Radio } from "antd";
import TextField from "../../Components/Commons/Forms/TextField";
import { toast } from "react-toastify";
import {
  updateOutPatient,
  getOutPatient
} from "../../Components/Helpers/API/CheckUpApi/CheckUpApi"
import { validateOutpatientForm } from "../../Components/Helpers/Utilities/Validations/CheckUp";

export default function ViewPending({ show, onHide, data, removeFromQueue }) {
  const [isClicked, setIsClicked] = useState(false);
  const [addPayment, setAddPayment] = useState({
    professional_fee_method: "cash"
  });
  const [isError, setIsError] = useState({
    professional_fee: false,
    hmo_type: false,
    hmo_id: false,
    reference_no: false,
  });

  useEffect(() => {
    async function fetchOutPatient() {
    
        const res = await getOutPatient(data?.outpatient_id, "");
        if (res.data) {
          setAddPayment(res.data.data[0]);
        } else if (res.error) {
          setAddPayment([]);
        }
    
    }

    fetchOutPatient();

  }, [data?.outpatient_id]);
  
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    if (name === "professional_fee_method" && value === "free") {
      setAddPayment((prevState) => ({
        ...prevState,
        professional_fee: "0",
        [name]: value,
      }));
    }
    setAddPayment((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  async function editFee() {
    setIsClicked(true);
    if (validateOutpatientForm(addPayment, setIsError)) {
      const response = await updateOutPatient(
        addPayment,
        data.patient_id,
        data.assessment_id,
        data.outpatient_id  
      );
      if (response.data) {
        toast.success(response.data.message);
        removeFromQueue(data.patient_id)
        setTimeout(() => {
          refreshPage()
        }, 1000);
      } else if (response.error) {
        response.error.data.messages.error_messages.forEach((errMsg) =>
          toast.error(errMsg)
        );
      }
    }
    setIsClicked(false);
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      size="lg"
      //   centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="form-title">
          View Pending No. {data?.id}
        </Modal.Title>
      </Modal.Header>
      {JSON.stringify(data) !== "{}" && (
        <Modal.Body>
          <Row>
            <Col xs={3} className="assessment-form-label">
              Name
            </Col>
            <Col className="text-muted">{data?.patient_name}</Col>
          </Row>
          <Row>
            <Col xs={3} className="assessment-form-label">
              Phone Number
            </Col>
            <Col className="text-muted">{data?.patient_phone_no}</Col>
          </Row>
          <Row>
            <Col xs={3} className="assessment-form-label">
              Sex
            </Col>
            <Col className="text-muted">{data?.patient_sex}</Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={4}>
              <TextField
                required
                id="professional_fee"
                name="professional_fee"
                formLabel={`Professional Fee (Php)`}
                size={`sm`}
                disabled={
                  addPayment.professional_fee_method === "free" ||
                  isClicked
                }
                value={addPayment.professional_fee}
                onChange={handleAddChange}
                isError={isError.professional_fee}
                setIsError={setIsError}
                errorMessage="Professional fee is required."
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
                <p className="form-label align-left">
                  PF Method <span className="badge">*</span>
                </p>
                <Radio.Group
                  name="professional_fee_method"
                  buttonStyle="solid"
                  value={addPayment.professional_fee_method}
                  style={{ width: "100%" }}
                  onChange={handleAddChange}
                  disabled={isClicked}
                >
                  <Radio.Button value="cash">Cash</Radio.Button>
                  <Radio.Button value="gcash">GCash</Radio.Button>
                  <Radio.Button value="hmo">HMO</Radio.Button>
                  <Radio.Button value="free">Free</Radio.Button>
                </Radio.Group>
              </Col>
              {addPayment.professional_fee_method === "gcash" && (
                <Col xs={6}>
                  <TextField
                    required
                    id="reference_no"
                    name="reference_no"
                    formLabel={`Reference No.`}
                    size={`sm`}
                    value={addPayment.reference_no}
                    onChange={handleAddChange}
                    isError={isError.reference_no}
                    setIsError={setIsError}
                    errorMessage="GCash reference no. is required."
                  />
                </Col>
              )}
              {addPayment.professional_fee_method === "hmo" && (
                <>
                  <Col>
                    <TextField
                      required
                      id="hmo_type"
                      name="hmo_type"
                      formLabel={`HMO Type`}
                      size={`sm`}
                      value={addPayment.hmo_type}
                      onChange={handleAddChange}
                      isError={isError.hmo_type}
                      setIsError={setIsError}
                      errorMessage="HMO type is required."
                    />
                  </Col>
                  <Col>
                    <TextField
                      required
                      id="hmo_id"
                      name="hmo_id"
                      formLabel={`HMO ID`}
                      size={`sm`}
                      value={addPayment.hmo_id}
                      onChange={handleAddChange}
                      isError={isError.hmo_id}
                      setIsError={setIsError}
                      errorMessage="HMO ID is required."
                    />
                  </Col>
                </>
              )}
            </Row>
        </Modal.Body>
      )}
      <Modal.Footer>
        <Row>
          <Col xs={6}>
            <BtnDelete label={`Close`} onClick={onHide} outline />
          </Col>
          <Col xs={6}>
            <BtnAdd
              label={"Save"}
              onClick={editFee}
              isClicked={isClicked}
            />
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
